import { createAction } from 'redux-actions';
import * as ActionTypes from './ActionTypes';

export const getSsoStatus = createAction(ActionTypes.GET_SSO_STATUS.REQUEST);

const initialState = {
    authStatus : "",
    needRedirect : false,
    redirectUrl : ""
}

function ssoStatus(state = initialState, action) {

    switch(action.type) {
       
        case ActionTypes.GET_SSO_STATUS.REQUEST: 
            return {...state}   //
        case ActionTypes.GET_SSO_STATUS.SUCCESS:  // 성공적으로 받았을 경우
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}

export default ssoStatus;